var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-button",on:{"click":_vm.actionClick}},[(!_vm.loadingState)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_c('loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }